import React from 'react';
import styled from 'styled-components';
import Avatar from 'components/avatar';
import { formatPhone } from 'utils/phoneHelpers';

const Container = styled.div`
  background-color: #fff;
  border: 1px solid #e1e5eb;
  padding: 10px 20px;
  border-radius: 6px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  .body {
    flex: 1;
  }
  .avatar {
    background-color: #eee;
  }
`;

const LogoWrapper = styled.div`
  width: 200px;
  height: 60px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${({ url }) => url || ''}');
`;

export default ({ location, className }) => {
  if (!location?.aptlyListings?.contactName && !location?.companyInfo?.logo) {
    return <></>;
  }

  return (
    <Container className={className}>
      <div>
        <strong>Questions or concerns?</strong> Let's talk!
      </div>
      <Wrapper>
        {(location?.aptlyListings?.contactImage || location?.aptlyListings?.duogram) && (
          <Avatar
            size={40}
            imageUrl={location?.aptlyListings?.contactImage}
            duogram={location?.aptlyListings?.duogram}
          />
        )}
        {!!location?.aptlyListings?.contactName && (
          <div className="body">
            <div className="name">{location?.aptlyListings?.contactName}</div>
            <div className="phone">{formatPhone(location?.aptlyListings?.contactPhone)}</div>
            <div className="email">{location?.aptlyListings?.contactEmail}</div>
          </div>
        )}
      </Wrapper>
      {!!location?.companyInfo?.logo && <LogoWrapper url={location?.companyInfo?.logo} />}
    </Container>
  );
};
